import React from 'react';
import { Award, Users, Leaf, Heart } from 'lucide-react';
import { Card, CardContent } from '../components/ui/card';

const About = () => {
  const values = [
    {
      icon: Award,
      title: 'Premium Quality',
      description: 'We source only the finest materials and work with master craftsmen to ensure every product meets our exacting standards.'
    },
    {
      icon: Users,
      title: 'Customer First',
      description: 'Your satisfaction is our priority. We provide exceptional service and support at every step of your journey.'
    },
    {
      icon: Leaf,
      title: 'Authentic Selection',
      description: '100% genuine products from trusted manufacturers. No imitations, only the real deal.'
    },
    {
      icon: Heart,
      title: 'Passion & Expertise',
      description: 'Our team consists of hookah enthusiasts who understand what makes a truly exceptional experience.'
    }
  ];

  return (
    <div className="min-h-screen">
      {/* Hero */}
      <section className="bg-[#0a1128] text-white py-20">
        <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="font-display text-5xl md:text-6xl font-bold mb-6">
            About Smith, hookah supply Co.
          </h1>
          <p className="text-xl text-gray-300 leading-relaxed">
            Elevating the art of hookah since 2025. A legacy of luxury, quality, and exceptional service.
          </p>
        </div>
      </section>

      {/* Story */}
      <section className="py-20 bg-white">
        <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8">
          <div className="prose prose-lg max-w-none">
            <h2 className="font-display text-3xl font-bold text-[#0a1128] mb-6">
              Our Story
            </h2>
            <p className="text-gray-700 leading-relaxed mb-6">
              Founded in 2025, Smith, hookah supply Co. was born from a passion for bringing the finest hookah experience to enthusiasts worldwide. What started as a small boutique has grown into a premier destination for luxury hookah products.
            </p>
            <p className="text-gray-700 leading-relaxed mb-6">
              Our founder, inspired by centuries-old traditions and modern luxury, envisioned a company that would bridge the gap between heritage and contemporary excellence. Today, we're proud to serve thousands of satisfied customers who appreciate quality, authenticity, and exceptional service.
            </p>
            <p className="text-gray-700 leading-relaxed">
              Every product in our collection is carefully curated and tested by our team of experts. We work directly with master craftsmen and trusted suppliers to ensure that each piece meets our rigorous standards for quality, craftsmanship, and performance.
            </p>
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="py-20 bg-gray-50">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="font-display text-4xl font-bold text-[#0a1128] mb-4">
              Our Values
            </h2>
            <p className="text-xl text-gray-600">
              The principles that guide everything we do
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {values.map((value, index) => {
              const Icon = value.icon;
              return (
                <Card key={index} className="border-gray-200 hover-lift">
                  <CardContent className="p-8">
                    <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-[#D4AF37]/10 mb-4">
                      <Icon className="h-8 w-8 text-[#D4AF37]" />
                    </div>
                    <h3 className="text-2xl font-semibold text-[#0a1128] mb-3">
                      {value.title}
                    </h3>
                    <p className="text-gray-600 leading-relaxed">
                      {value.description}
                    </p>
                  </CardContent>
                </Card>
              );
            })}
          </div>
        </div>
      </section>

      {/* Stats */}
      <section className="py-20 bg-[#0a1128] text-white">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
            <div>
              <div className="text-5xl font-bold text-[#D4AF37] mb-2">1+</div>
              <div className="text-gray-300">Years of Excellence</div>
            </div>
            <div>
              <div className="text-5xl font-bold text-[#D4AF37] mb-2">50K+</div>
              <div className="text-gray-300">Happy Customers</div>
            </div>
            <div>
              <div className="text-5xl font-bold text-[#D4AF37] mb-2">200+</div>
              <div className="text-gray-300">Premium Products</div>
            </div>
            <div>
              <div className="text-5xl font-bold text-[#D4AF37] mb-2">99%</div>
              <div className="text-gray-300">Satisfaction Rate</div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;